import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'app-leavestatusform',
  templateUrl: './leavestatusform.component.html',
  styleUrls: ['./leavestatusform.component.scss']
})
export class LeavestatusformComponent implements OnInit {

  savingFlag: boolean = false;
  form: any = {};
  employee_id: any

  pageType: any;
  constructor(public rout: Router,public alert: DialogComponent, public dialog: DialogComponent,public toast: ToastrManager, public service: DatabaseService, public route: ActivatedRoute) {
    this.form.status='Reject'
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log('====================================');
      console.log(params);
      console.log('====================================');
      this.employee_id = params.id;
      this.form.leaveId = params.id;
    });

  }

  goBack() {
    window.history.back();
  }

  submitForm() {
    this.savingFlag = true;
    this.service.post_rqst({ 'data': this.form }, "CronJob/rejectStatusChange").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.dialog.success("Rejected", "Successfully");
        this.savingFlag = false;
        this.rout.navigate(['/thanks/' + this.employee_id]);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    }, err => {
      this.savingFlag = false;
    })
  }





}

